const model = {
  state: {
    menuPlatformCode: 'FS',
    authPointPlatformCode: 'FS',
    activeCategory: '',
    platformCode: 'FS',
    hasChildren: false, //选中菜单是否有子菜单
    topCategory: {
      categoryId: '',
      categoryName: '',
    },
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { BindMenu }, getState }) => ({
    setPlatformCode(value) {
      BindMenu.setState({ platformCode: value });
    },
    setActiveCategory(value) {
      BindMenu.setState({ activeCategory: value });
    },
    setHasChildren(value) {
      BindMenu.setState({ hasChildren: value });
    },
    setTopCategory(value) {
      BindMenu.setState({ topCategory: value });
    },
    initData() {
      BindMenu.setState({
        platformCode: 'FS',
        activeCategory: '',
        hasChildren: false,
      });
    },
    changeMenuPlatformCode(params) {
      BindMenu.setState({ menuPlatformCode: params });
    },
    changeAuthPointPlatformCode(params) {
      BindMenu.setState({ authPointPlatformCode: params });
    },
  }),
};

export default model;
